import script from "./HomepagePricing.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepagePricing.vue?vue&type=script&setup=true&lang=js"

import "./HomepagePricing.vue?vue&type=style&index=0&id=3ddd6bd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ddd6bd4"]])

export default __exports__